import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { priceConfigsApi, sellersApi, type PriceConfig, type SellerListItem } from '../lib/api';
import { useAuth } from '../lib/auth';

export default function PriceConfigsList() {
  const { user } = useAuth();
  const [configs, setConfigs] = useState<PriceConfig[] | null>(null);
  const [sellers, setSellers] = useState<SellerListItem[]>([]);
  const [filterSeller, setFilterSeller] = useState<number | ''>('');
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    if (user?.role === 'admin') {
      sellersApi.list().then((r) => setSellers(r.sellers)).catch(() => { /* noop */ });
    }
  }, [user]);

  useEffect(() => {
    priceConfigsApi.list(filterSeller || undefined)
      .then((r) => setConfigs(r.configs))
      .catch((e) => setErr(String(e?.message ?? e)));
  }, [filterSeller]);

  function sellerLabel(id: number) {
    const s = sellers.find((x) => x.id === id);
    return s ? (s.display_name || s.login) : `#${id}`;
  }

  if (err) return <div className="container"><div className="error">{err}</div></div>;
  if (!configs) return <div className="container"><p className="muted">Загрузка…</p></div>;

  return (
    <div className="container">
      <div className="page-head">
        <h2>Шаблоны прайсов</h2>
        <div className="row">
          <Link to="/prices/imports" className="btn">→ История загрузок</Link>
          <Link to="/prices/configs/new" className="btn primary">+ Новый шаблон</Link>
        </div>
      </div>

      {user?.role === 'admin' && (
        <div className="row" style={{ marginBottom: 14 }}>
          <label className="muted">Продавец:</label>
          <select
            value={filterSeller}
            onChange={(e) => setFilterSeller(e.target.value ? Number(e.target.value) : '')}
          >
            <option value="">Все</option>
            {sellers.map((s) => (
              <option key={s.id} value={s.id}>{s.display_name || s.login}</option>
            ))}
          </select>
        </div>
      )}

      {configs.length === 0 ? (
        <p className="muted">Шаблонов нет. Создай первый, опираясь на пример .xlsx от продавца.</p>
      ) : (
        <table className="grid">
          <thead>
            <tr>
              <th>#</th>
              <th>Название</th>
              {user?.role === 'admin' && <th>Продавец</th>}
              <th>Лист</th>
              <th>Шапка</th>
              <th>Маппинг (полей)</th>
              <th>По умолч.</th>
            </tr>
          </thead>
          <tbody>
            {configs.map((c) => (
              <tr key={c.id}>
                <td>{c.id}</td>
                <td><Link to={`/prices/configs/${c.id}`}>{c.name}</Link></td>
                {user?.role === 'admin' && <td>{sellerLabel(c.seller_id)}</td>}
                <td>{c.sheet_index}</td>
                <td>строка {c.header_row}</td>
                <td>{Object.keys(c.column_map).length}</td>
                <td>{c.is_default ? '✓' : '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
